import {injectElement} from './element';

const scriptDom = 'script';

/**
 * @param {string} path
 * @param {boolean} [async]
 * @param {Document} [doc]
 * @return {?HTMLScriptElement}
 */
export function injectScript(path, async = true, doc = document) {
  if (path) {
    const script = injectElement(scriptDom, doc);
    script.charset = 'utf-8';
    script.async = async;
    script.crossOrigin = 'anonymous';
    script.src = path;
    doc.head.appendChild(script);

    return script;
  }
}

/**
 * @param {string} data
 * @param {Document} [doc]
 * @return {?HTMLScriptElement}
 */
export function injectScriptInline(data, doc = document) {
  if (data) {
    const script = injectElement(scriptDom, doc);
    script.innerHTML = data;
    doc.body.appendChild(script);

    return script;
  }
}
